<div class="breadcrumb-container">
    <div class="row">
        <div class="col-lg-12">
            <h1>Print Management</h1>
            <ol class="breadcrumb" id="breadcrumbNav">
                <li>
                    <a [routerLink]="['/home']">
                        <i class="fa fa-home "></i>
                        <span>ProManual </span>
                    </a>
                </li>
                <li class="active">
                    <i class="fa fa-print"></i>
                    <span>Print Management - Users</span>
                </li>
            </ol>
        </div>
    </div>
</div>
<div class="component-container">
    <pmuser-list></pmuser-list>
</div>